import { mergeStyles, Stack, useTheme, Text } from '@fluentui/react';
import React, { useMemo } from 'react';

interface KeyValueCardProps {
    keyValuePairs: { key: string; value: string }[];
}


const KeyValueCard: React.FC<KeyValueCardProps> = ({ keyValuePairs }) => {

    const theme = useTheme();

    const headerStyles = { root: { fontWeight: '680', } };

    const tBodyClass = useMemo(() => {
        return mergeStyles({
            "td": {
            },
            "& > :nth-child(even)": {
                backgroundColor: theme.semanticColors.bodyDivider,
            }
        });
    }, [theme]);

    const styleSummary = useMemo(() => {
        const styleSummary: Record<string, React.CSSProperties> = {
            "dl": {
                width: '100%',
                padding: '5px',
            },
            "dt": {
                fontWeight: 680,
                textAlign: 'right',
                width: "210px",
                padding: '5px',
            },
            "dd": {
                padding: '5px',
            }
        }
        return styleSummary;
    }, []);


    return (
        <Stack>
            <table style={styleSummary.dl} >
                <tbody className={tBodyClass}>
                    {keyValuePairs.map(({ key, value }, index) => {
                        return (
                            <tr key={index}>
                                <td style={styleSummary.dt}>
                                    <Text styles={headerStyles}>
                                        {key}
                                    </Text>
                                </td>
                                <td style={styleSummary.dd}>
                                    <Text>
                                        {value}
                                    </Text>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

        </Stack>
    );
};

export default KeyValueCard;